{
  "1e3564bdba890599": "Notification Preferences",
  "4840a57222fc401c": "Deactivated",
  "4ba2056e9ba62960": "Web Push",
  "5c81e533cbb65983": "SMS notifications are disabled because no mobile number is set. Add a mobile number in Personal Information to enable SMS notifications.",
  "731ce7ed808913b2": "Push",
  "92340695899bd2d8": "Active",
  "969ccbd3cf6300ec": "Email",
  "c8df66c5fe3f97d0": "Close dialog",
  "e2204b3eaff613de": "Team Members"
}
